import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PrintService } from '../../../services/print.service';
import { find } from 'lodash';
import { Story } from 'app/+stories/interfaces/story';
import { concatMap } from 'rxjs/operators';
import { FirebaseService } from 'app/services/firebase.service';

@Component({
  selector: 'print-step-1',
  styleUrls: ['../../wizard/wizard.component.scss', './step1.component.scss'],
  templateUrl: './step1.component.html',
})
export class PrintStep1Component implements OnInit {
  @Input() step;
  @Input() totalSteps;
  @Input() next;
  storyId;
  story;
  promocodeModalVisible;
  promocodeError;

  constructor(
    public printService: PrintService,
    public translate: TranslateService,
    public activatedRoute: ActivatedRoute,
    private firebaseService: FirebaseService
  ) {}

  ngOnInit() {
    this.storyId = this.activatedRoute.snapshot.params.id;
    this.printService
      .fetchStory(this.storyId)
      .pipe(
        concatMap((story: Story) => {
          this.printService.projectId = story.project;
          this.story = story;
          return this.printService.getBookformatsWithFallback(
            story.id,
            this.printService.specs.discount_code
          );
        })
      )
      .subscribe(() => {
        const selectedBookformat = this.printService.bookformats.find(
          bookformat => bookformat.id === this.story.book_format
        );
      });
  }

  public selectFormat(id) {
    this.firebaseService.logEvent('checkout_book_format_update', {
      print_order_id: this.printService.printOrder.id,
      story_id: this.printService.storyId,
      project_id: this.printService.projectId,
      book_format_id: id,
      currency: this.printService.bookformats.find(
        bookformat => bookformat.id === id
      ).currency,
      product_price: this.printService.bookformats.find(
        bookformat => bookformat.id === id
      ).book_price,
    });
    this.printService.specs.book_format_id = id;
  }

  public isFormatSelected(id) {
    return this.printService.specs.book_format_id === id;
  }

  public getShape(bookformat) {
    const key = bookformat.width === bookformat.height ? 'square' : 'rectangle';
    return this.translate.get(key);
  }

  addPromocode() {
    this.promocodeError = undefined;
    this.promocodeModalVisible = true;
  }

  hidePromocodeModal() {
    this.promocodeModalVisible = false;
  }

  submitPromocode(promocode) {
    this.printService.loadBookformats(this.storyId, promocode).subscribe(
      () => {
        this.hidePromocodeModal();
        this.firebaseService.logEvent('checkout_discount_enter', {
          print_order_id: this.printService.printOrder.id,
          story_id: this.storyId,
          project_id: this.printService.projectId,
          discount_code: promocode,
        });
      },
      response => {
        this.promocodeError = response.error[0];
      }
    );
  }

  getBookformat(id) {
    return find(this.printService.bookformats, item => item.id === id);
  }

  submit() {
    const id = this.printService.specs.book_format_id;
    const selected = this.getBookformat(id);
    this.printService.selectedBookFormat = selected;
    this.firebaseService.logEvent('checkout_book_format_select', {
      story_id: this.printService.storyId,
      project_id: this.printService.projectId,
      book_format_id: id,
      currency: this.printService.bookformats.find(
        bookformat => bookformat.id === id
      ).currency,
      product_price: this.printService.bookformats.find(
        bookformat => bookformat.id === id
      ).book_price,
    });
    this.next();
  }
}
